import "./AboutMe.css";

export default function AboutMe() {
  return (
    <article className="AboutMe" id="About">
      <h2 className="AboutMe__title">About Me</h2>
      <p className="AboutMe__text">
        I am an experienced Web developer with a strong background in Android
        app development.
        <br />I have a passion for creating innovative and user-friendly digital
        products that enhance the online experience for users.
        <br /> I am dedicated to delivering high-quality work and am committed
        to helping my clients achieve their goals.
        <br />
        Whether you need a new website or mobile app, I am confident in my
        ability to deliver a product that exceeds your expectations.
      </p>
    </article>
  );
}
